import { CreditCardStatementResponse } from "@/models/api/finances/CreditCardStatementListItem";

export default {
  page: 0,
  totalCount: 3,
  items: [
    {
      transactionDate: "2020-12-01T00:00:00",
      accountingDate: "2020-12-01T00:00:00",
      amount: -10,
      description:
        "Naliczenie prowizji na karcie Opłata za korzystanie z karty 11 2020.11.02 - 2020.12.01 2020.12.01 42 z   42 ",
      transactionNumber: "WR/22/12/2020/5543",
    },
    {
      transactionDate: "2020-12-01T00:00:00",
      accountingDate: "2020-12-01T00:00:00",
      amount: -10,
      description: "Naliczenie prowizji na karcie Opłata za korzystanie z karty ",
      transactionNumber: "WR/23/12/2020/5543",
    },
    {
      transactionDate: "2020-12-01T00:00:00",
      accountingDate: "2020-12-01T00:00:00",
      amount: -10,
      description: "Naliczenie prowizji na karcie Opłata za korzystanie z karty ",
      transactionNumber: "WR/24/12/2020/5543",
    },
  ],
} as CreditCardStatementResponse;
